import { createCRUDHook } from './createCRUDHook';
import { WorkingDayDto } from 'utils/models';
import { TBL_WORKING_DAY } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<WorkingDayDto>({
  entityName: 'WorkingDay',
  endpoint: TBL_WORKING_DAY,
});

export const WorkingDayContext = Context;
export const useWorkingDayManager = useManager;
export const useWorkingDay = useConsumer;
